import { call, put } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { PAST_PERFORMANCES_CUTOFF_HOUR } from 'selectors/event-group'
import { getPrevHour } from 'utils/datetime'

import { fetchEntity, fetchPaginate } from 'utils/sagas'


const { eventGroup, eventGroupPerformances, eventGroupPastPerformances } = actions

const fetchEventGroup = fetchEntity.bind(null, eventGroup, api.fetchEventGroup)
const fetchEventGroupPerformances = fetchEntity.bind(null, eventGroupPerformances, api.fetchEventGroupPerformances)
const fetchEventGroupPastPerformances = fetchEntity.bind(
  null,
  eventGroupPastPerformances,
  api.fetchEventGroupPerformances
)

export function* eventGroupLoadPage({ eventGroupId }) {
  yield call(fetchEventGroup, eventGroupId)
  yield put(actions.eventGroupLoadPerformances(eventGroupId))
  yield put(actions.eventGroupLoadPastPerformances(eventGroupId))
}

export function* eventGroupLoadPerformances({ eventGroupId, nextPage }) {
  yield fetchPaginate(
    fetchEventGroupPerformances,
    'eventGroupPerformances',
    eventGroupId,
    nextPage,
    { minStartTime: getPrevHour(PAST_PERFORMANCES_CUTOFF_HOUR) }
  )
}

export function* eventGroupLoadPastPerformances({ eventGroupId, nextPage }) {
  yield fetchPaginate(
    fetchEventGroupPastPerformances,
    'eventGroupPastPerformances',
    eventGroupId,
    nextPage,
    { maxStartTime: getPrevHour(PAST_PERFORMANCES_CUTOFF_HOUR), reverseStartTimeOrder: true }
  )
}



/** WEBPACK FOOTER **
 ** ./src/sagas/event-group/event-group-sagas.js
 **/